<template>
    <div class='component-page'>
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
               
                <Col span="2" style='float:right'>
                <i-button icon="md-add" shape="circle" type="primary" @click="add_new">添加</i-button>
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <Modal v-model="addModel" width="800" title="新增">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">

                    <Row>
                        <Col span="11">
                            <FormItem label="套餐名称" prop='name'>
                                <Input v-model="formData.name" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="会员时长" prop='duration'>
                                <Input v-model="formData.duration" style='float:left;width:94%' placeholder="请输入..."></Input> &nbsp;天
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="排序" prop='sort'>
                                <Input v-model="formData.sort" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="价格" prop='money'>
                                <Input v-model="formData.money" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle"  ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle"  @click="save('formData')">确定</Button>
            </div>
        </Modal>
         <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
        addModify,
        setDel,
        setStatus
    } from '@/api/memberPricing'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                },
                start_time: '',
                end_time: '',
                addModel:false,//添加修改弹出层状态
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                package_id:'',
                formData:{
                    package_id:'',
                    name:'',
                    duration:'',
                    sort:'',
                    money:'',
                },
                verificationRule:{
                    name: [
                        { required: true, message: '不能为空'}
                    ],
                    duration: [
                        { required: true, message: '不能为空'}
                    ],
                    sort: [
                        { required: true, message: '不能为空'}
                    ],
                    money: [
                        { required: true, message: '不能为空'}
                    ],
                },
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '套餐名称',
                        align: 'center',
                        key: 'name',

                    },
                    {
                        title: '价格',
                        align: 'center',
                        key: 'money',
                    },
                  
                    {
                        title: '时长',
                        align: 'center',
                        key: 'duration',
                     
                    },
                    {
                        title: '排序',
                        align: 'center',
                        key: 'sort',
                      
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                     {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 200,
                        render: (h, params) => {
                            if(params.row.status==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.package_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.package_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.package_id,'确定上架该定价吗？')
                                            }
                                        }
                                    }, '上架'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.package_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.package_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.package_id,'确定下架该定价吗？')
                                            }
                                        }
                                    }, '下架'),
                                ])
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
             // 添加
            add_new(){
                this.formData.package_id='';
                this.formData.name='';
                this.formData.duration='';
                this.formData.sort='';
                this.formData.money='';

                this.addModel=true;
            },
             // 修改获取详情
            edit(id){
                fetchInfo({
                    package_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formData=res.data;
                        this.addModel=true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();

                                this.addModel=false;
                            } else if (res.code == 14001) {
                            this.$Message.error(res.msg)
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                name: 'login'
                                })
                            })
                            } else {
                            this.$Message.error(res.msg)
                            }
                        })
                    
                    }
                })
            },
            // 删除
            delete(id) {
                this.package_id = id;
                this.remindContent = '确定删除该定价吗？';
                this.remindModal = true; 
            },
            // 改变状态
            changeStatus(id,info){
                this.package_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                if(this.remindContent == '确定删除该定价吗？'){
                    setDel({
                        package_id:this.package_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setStatus({
                        package_id:this.package_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
